import { render, staticRenderFns } from "./DesconsiderarPedidoEmTransito.vue?vue&type=template&id=835571ba&scoped=true"
import script from "./DesconsiderarPedidoEmTransito.vue?vue&type=script&lang=js"
export * from "./DesconsiderarPedidoEmTransito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835571ba",
  null
  
)

export default component.exports